import { render, staticRenderFns } from "./Vrachtwagens.vue?vue&type=template&id=658b35fe&"
import script from "./Vrachtwagens.vue?vue&type=script&lang=js&"
export * from "./Vrachtwagens.vue?vue&type=script&lang=js&"
import style0 from "./Vrachtwagens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports